import type { ExpressionSpecification } from "maplibre-gl";
import { pick, titleCase, type LayerStyle } from "./types";

const EXISTING = "#3b8f4e";
const PLANNED = "#aa711d";

const style: LayerStyle = {
  id: "coa-trails",
  minzoom: 10,
  maxzoom: 15,
  layers(source) {
    const existing: ExpressionSpecification = ["==", ["get", "BUILD_STATUS"], "EXISTING"];
    return [
      {
        id: `${this.id}:line`,
        type: "line",
        source,
        "source-layer": this.id,
        minzoom: this.minzoom,
        paint: { "line-color": ["case", existing, EXISTING, PLANNED], "line-width": ["interpolate", ["linear"], ["zoom"], 10, 1, 15, 3] },
      },
    ];
  },
  legend: [
    { label: "Existing urban trail", color: EXISTING },
    { label: "Planned or under construction", color: PLANNED },
  ],
  describe: (p) =>
    pick(p, [
      ["URBAN_TRAIL_NAME", "Trail"],
      ["URBAN_TRAIL_SYSTEM_NAME", "Trail system"],
      ["BUILD_STATUS", "Status", titleCase],
      ["TRAIL_SURFACE_TYPE", "Surface", titleCase],
      ["LENGTH_MILES", "Length (mi)", (v) => (Number.isFinite(Number(v)) ? Number(v).toFixed(2) : String(v))],
    ]),
};

export default style;
